import { render, staticRenderFns } from "./FaultRecordDialog.vue?vue&type=template&id=0ccaa40a&scoped=true&"
import script from "./FaultRecordDialog.vue?vue&type=script&lang=js&"
export * from "./FaultRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccaa40a",
  null
  
)

export default component.exports